import React from 'react';
import { LanyardButtonProps } from '../Contentful/transformers/ButtonTransformer';
import Button from '@jbhi-fi/lanyard-ui/components/Button/Button';
import { styles } from './ButtonBlock.css';

export interface ButtonBlockProps {
  alignment: 'Left' | 'Centred';
  buttons: Array<LanyardButtonProps>;
  divider?: string;
}

export const ButtonBlock = ({ buttons, alignment, divider }: ButtonBlockProps) => {
  const isCentred = alignment === 'Centred';
  if (!buttons?.length) return null;
  return (
    <div className={styles.buttonContainer({ isCentred })}>
      {buttons.map((button, index) => (
        <React.Fragment key={index}>
          <Button {...button}></Button>
          {divider ? index < buttons.length - 1 && <span aria-hidden="true">{divider}</span> : null}
        </React.Fragment>
      ))}
    </div>
  );
};
